import React, { useEffect, useState } from "react";
import { Login } from "./Login";
import Register from "./Register";
import About from "./About";
import Features from "./Features";
import { Trans } from "react-i18next";
import { compose, withStateHandlers } from "recompose";
import { withResolver } from "components/common";
import { useRecoilState } from "recoil";
import { modalState } from "../../atoms";
import Mailchimb1 from "./Mailchimb1";
import queryString from 'query-string';
import { useTranslation } from "react-i18next";
import TextFader from './TextFader'

import {
  Modal, ModalBody
} from 'reactstrap';
import { PlansList } from "pages/Subscription/PlansList";
import ZatcaSection from "./ZatcaSection";
import { CurrencySymbol } from "services/util";

const applications_icons = [
  'apicbase application.png',
  'loyverse application.png',
  'marn application.png',
  'Rahatak Application.png',
  'salla application.png',
  'zid application.png',
]

const TRANSLATIONS = [
  { text: "Join Hesaab and explore your daily transactions in multiple languages.", dir: "ltr" }, // English
  { text: "انضم إلى حساب واستكشف معاملاتك اليومية بعدة لغات.", dir: "rtl" }, // Arabic
  { text: "Rejoignez Hesaab et explorez vos transactions quotidiennes dans plusieurs langues.", dir: "ltr" }, // French
  { text: "Únete a Hesaab y explora tus transacciones diarias en varios idiomas.", dir: "ltr" }, // Spanish
  { text: "Bergabunglah dengan Hesaab dan jelajahi transaksi harian Anda dalam berbagai bahasa.", dir: "ltr" }, // Indonesian
  { text: "加入 Hesaab，探索您以多种语言进行的日常交易。", dir: "ltr" }, // Chinese
  { text: "Hesaab'a katılın ve günlük işlemlerinizi birden fazla dilde keşfedin.", dir: "ltr" }, // Turkish
  { text: "Treten Sie Hesaab bei und entdecken Sie Ihre täglichen Transaktionen in mehreren Sprachen.", dir: "ltr" }, // German
  { text: "Hesaabに参加して、複数の言語で日々の取引を探索してください。", dir: "ltr" }, // Japanese
  { text: "Unisciti a Hesaab ed esplora le tue transazioni quotidiane in più lingue.", dir: "ltr" }, // Italian
  { text: "Присоединяйтесь к Hesaab и изучайте свои ежедневные транзакции на нескольких языках.", dir: "ltr" } // Russian
];


export const LandingPage = ({
  history,
  location,
  client,
  focusFirstName,
  handleToggleFirstName,
  setFocusFirstName,
  modalType,
  subscriptionPlans,
}) => {
  const [modal, setModal] = useRecoilState(modalState);
  const toggle = () => setModal(!modal);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation()

  let hashParts = location.hash.split('?')
  let ref_code = '';

  if (hashParts.length > 1) {
    let searchParams = queryString.parse(hashParts[1])
    ref_code = searchParams.ref_code;
  }

  useEffect(() => {
    if (ref_code) {
      localStorage.setItem('referral_code', ref_code)
    }

  }, [location.hash])

  useEffect(() => {
    setLoading(true);
    if (modalType === 'login' || modalType === 'register') {
      setTimeout(() => {
        setLoading(false);
      }, 800);
    }
  }, [modalType]);

  useEffect(() => {
    const isDirectLink = location.pathname === `/${modalType}`;

    if (isDirectLink) {
      setModal(true);
    } else {
      setModal(false);
    }
  }, [location.pathname, modalType, setModal]);

  const renderModalContent = () => {
    switch (modalType) {
      case 'login':
        return <Login history={history} toggle={toggle} />;
      case 'register':
        return (
          <Register
            onToggleFirstName={handleToggleFirstName}
            focusFirstName={focusFirstName}
            history={history}
            client={client}
            toggle={toggle}
          />
        );
      default:
        return null;
    }
  };

  const subscriptionPlanRows = [];

  for (let i = 0; i < subscriptionPlans.length; i += 4) {
    const subset = subscriptionPlans.slice(i, i + 4).filter(item => item.order < 5);
    if (subset.length > 0) {
      subscriptionPlanRows.push(subset);
    }
  }

  return (
    <div className="theone">
      <header id="header-6" className="dark-header">
        <div className="container">
          <div className="header-content">
            <div className="row align-items-center">
              <div className="col-md-6 col-lg-6 header-content-details" id="about-us">
                <h3 className="header-brand">
                  <TextFader texts={TRANSLATIONS}/>
                </h3>
                <p>

                  <span className="txt-decoration"><Trans>Hesaab</Trans></span> <Trans> is a program designed to integrate with the Xero program and read data in multiple languages, in addition to the HR & payroll system and electronic invoicing.
                  </Trans>
                </p>
                <a
                  className="btn btn-primary-filled btn-rounded"
                  onClick={(e) => {
                    e.preventDefault();
                    setFocusFirstName(true);
                    toggle();
                  }}
                  href="/get_started"
                >
                  <Trans>Start Free Trial</Trans>
                </a>
                <div>
                  <img style={{ marginTop: '10px' }} className="w-48"
                    src="/images/hessab&xero.svg"
                    alt="Arabic Invoicing Solution"
                  />
                </div>

              </div>
              <div className="col-md-6 col-lg-6">
                <img className="w-100"
                  src="/images/hesaab_platform2.png"
                  alt="Arabic Invoicing Solution"
                />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="row">
        <div className="col-md">
          <React.Fragment>
            <div style={{
              display: 'block', padding: 30
            }}>
              <Modal isOpen={modal}
                toggle={toggle}
              >
                <ModalBody>
                  {loading ? t('Loading...') : renderModalContent()}
                </ModalBody>
              </Modal>
            </div >
          </React.Fragment>
        </div>
      </div>
      <ZatcaSection />
      <Features />
      <About />
      <section id="integrated how market-place">
        <div className="row justify-content-center flex-wrap-nowrap mt-0 mb-5 pb-5 ">
          <div className="col-12 text-center">
            <h3 className="txt-title">
              <Trans>Marketplace</Trans>
            </h3>
            <p className="txt-content">
              <Trans>
                You can integrate your account with difference type of programs such as POS and e-commerce to simplify and manage your business with the highest efficiency.
              </Trans>
            </p>
            <div className="row justify-content-center mt-5">
              <div className="col-md-8 col-sm-12 row align-items-center">
                {applications_icons.map((icon, index) => (
                  <div className="col-md-2 col-4 px-2">
                    <img src={`/images/applications/${icon}`} alt={icon} className="img-thumbnail border-0 app-image shadow-none"/>
                  </div>  
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="pricing">
        <div className="container text-center">
          <h3 className="txt-title text-center">
            <Trans>Pricing</Trans>
          </h3>
          <p className="txt-content text-center">
            <Trans>Choose the best package for your business</Trans>
          </p>

          {
            subscriptionPlanRows && subscriptionPlanRows?.map((subscriptionPlanCol, rowIdx) => {
              return (
                <div key={rowIdx} className="row justify-content-center">

                  {subscriptionPlanCol && subscriptionPlanCol?.map((item, colIdx) => {
                    const languageList = item.subscription_plan_inclusives?.filter(i => i.content_type === "hesaablanguage")
                    const moduleList = item.subscription_plan_inclusives?.filter(i => i.content_type === "hesaabmodule")
                    const appList = item.subscription_plan_inclusives?.filter(i => i.content_type === "hesaabapplication")

                    return (<div key={colIdx} className="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center same-height">
                      <div className="featured pricing-table table-text-start" style={{ margin: '52px 0px 10px 0px', minHeight: '80%' }}>
                        <div className="pricing-table-title">
                          <h4 className="pricing-title">
                            <Trans>{item.name}</Trans>
                          </h4>
                        </div>
                        <div className="pricing-table-price">
                          <p>
                            <span className="pricing-price" dir="ltr"><CurrencySymbol currency={item.yearly_price?.currency}/>{parseInt(item.yearly_price?.price)}</span>
                            <span className="pricing-period">
                              / {item.name.includes("one-time") ? <Trans>one time</Trans> : <Trans>year</Trans>}
                            </span><br />
                            <span className="pricing-period">
                              <Trans>{item.yearly_price?.is_vat_included === true ? `Including vat` : `Excluding vat`}</Trans>
                            </span>
                          </p>
                        </div>
                        <div className="border-top mb-3" style={{ width: '70%' }}></div>
                        <PlansList moduleList={moduleList} appList={appList} languageList={languageList} featuresList={item?.feature_list} t={t} />

                        <div className="pricing-table-button" style={{ marginTop: 'auto' }}>
                          <a className="btn btn-primary-filled btn-rounded" onClick={(e) => {
                            e.preventDefault();
                            setFocusFirstName(true, item.id);
                            toggle();
                          }}
                            href="/get_started"
                          >
                            <span>
                              <Trans>Buy Now</Trans>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>)
                  })}
                </div>
              )
            })
          }
        </div>
        <div className="hint text-center">
          <span className="text-muted small font-weight-bold">*<Trans>Please contact the team to provide you with the details and procedures required for the Phase Two E-Invoicing (ZATCA) integration.</Trans></span>
        </div>
      </section>

      <section id="newsletter">
        <div className="container">
          <div className="header-content">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-10" >
                <h3 className="txt-title mb-4">
                  <Trans>Let’s keep in touch</Trans>
                </h3>
                <p className="txt-content mb-3">
                  <Trans>
                    Subscribe to our mailing list to get the latest updates and offers.
                  </Trans>
                </p>
                <Mailchimb1 />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
};

export const enhance = compose(
  withStateHandlers(
    {},
    {
      setFocusFirstName:
        (_, { location, history }) =>
          (focusFirstName, subscriptionPlan = null) => {
            if (subscriptionPlan) {
              history.push({
                pathname: '/register',
                search: `selected_plan=${subscriptionPlan}`
              })
            } else {
              history.push({
                pathname: '/register'
              })
            }
            return { focusFirstName };
          },
      handleToggleFirstName:
        ({ focusFirstName }) =>
          () => {
            return { focusFirstName: !focusFirstName };
          },

      setSubscriptionPlans: () => (subscriptionPlans) => ({ subscriptionPlans }),
    }
  ),
  withResolver(
    {
      subscriptionPlans: () => (client) => client.get("subscription-plans"),
    },
    {
      onResolved:
        ({ setSubscriptionPlans }) =>
          ({ subscriptionPlans }) =>
            setSubscriptionPlans(subscriptionPlans),
    }
  ),
);
export default enhance(LandingPage);
